import { Injectable } from '@angular/core';
import { Menu } from 'primeng/menu';

@Injectable({
  providedIn: 'root',
})
export class ToggleMenuService {
  constructor() {}

  private activeMenu: Menu | null = null;

  // Set a menu as the active menu
  openMenu(menu: Menu, event: Event) {
    if (this.activeMenu && this.activeMenu != menu) {
      this.activeMenu?.hide(); // Close the previously active menu
    }
    this.activeMenu = menu;
    menu.toggle(event);
  }

  isActiveMenu(menu: Menu): boolean {
    return this.activeMenu === menu;
  }

  // Close the active menu
  closeMenu() {
    if (this.activeMenu) {
      this.activeMenu.hide();
      this.activeMenu = null;
    }
  }
}
